import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { Grid } from "@mui/material";
import { getOnBoardCompliance } from "redux/actions/UserCompliance";
import {
  getVehicle,
  patchUpdateVehicle,
  postAddVehicle,
} from "redux/actions/UserVehicle";
import { getCar } from "redux/actions/UserCar";
import {
  filterStatusVehicle,
  vehicleDialogData,
} from "pages/vendor/VendorBreadCrumbData";
import CommonMultiImageForm from "components/commonMultiImageForm/CommonMultiImageForm";
import Loader from "components/loader/Loader";
import CommonTable from "components/commonTable/CommonTable";
import CommonButtonHeader from "components/commonButtonHeader/commonButtonHeader";

function VechileTable() {
  let vehicleStatus = JSON.parse(localStorage.getItem("vehicleStatus"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [open, setOpen] = useState(false);
  const [iconType, setIconType] = useState("Edit");
  const [iconId, setIconId] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companyId = localStorage.getItem("companyId");
  const vehicleData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const vehicleLoader = useSelector((state) => state?.userVehicle?.loading);

  const role = localStorage.getItem("role");
  const type = role === "subVendorCompany" ? "subVendor" : "vendor";

  const [status, setStatus] = useState(
    vehicleStatus?.length > 0 ? vehicleStatus : ""
  );
  const [search, setSearch] = useState("");

  const filterData = {
    id: companyId,
    type: type,
    status: status,
    page: page,
    pageSize: rowsPerPage,
    search: search,
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getVehicle({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getVehicle({ ...filterData, page: newPage }));
  };

  useEffect(() => {
    dispatch(getVehicle(filterData));
    dispatch(getCar());
  }, []);

  const postAddVehicleSuccess = useSelector(
    (state) => state?.userAddVehicle?.userAddVehicle?.success
  );
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const onSubmit = (val, code) => {
    const data = {
      ...val,
      carType: "COC",
      seating: parseInt(val?.seating),
      id: companyId,
      type: "vendor",
      avtar: selectedImage,
    };
    let formData = new FormData();
    Object.keys(data).map((val) => {
      formData.append(val, data[val]);
    });
    dispatch(postAddVehicle(formData));
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    } else {
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const onClickTableSubVendor = (val) => {
    localStorage.setItem("vehicleStatus", JSON.stringify(status));
    navigate("/Vehicle/details", {
      state: { vehicleId: val?.id, status: val?.status, name: val?.carModel },
    });
  };

  const onDialog = (data, code, val) => {
    const allData = {
      ...data,
      carType: "COC",
      seating: parseInt(data?.seating),
      id: companyId,
      type: "vendor",
      avtar: selectedImage,
    };
    let formData = new FormData();
    Object.keys(allData).map((data) => {
      formData.append(data, allData[data]);
    });
    dispatch(patchUpdateVehicle(formData));
  };

  const onClickMoreIcon = (val, iconType) => {
    setIconId(val.id);
    const data = {
      ...val,
      carType: "COC",
      seating: parseInt(val?.seating),
      id: val.id,
      type: "vendor",
      avtar: selectedImage,
    };
    const value = data;
    setDefaultValue(value);
    setIconId(data.id);
    if (iconType === "Delete") {
    } else if (iconType === "Edit") {
      setIconType(iconType);
      setOpen(true);
    } else if (iconType === "Upload Compliance") {
      setIconType(iconType);
      setOpen(true);
      const profileData = {
        vehicleId: val.id,
        type: "vehicleRegistration",
      };
      setShowOtherComponent(true);
      dispatch(getOnBoardCompliance(profileData));
    } else if (iconType === "Deactivate") {
      const profileData = {
        isApproved: "InActive",
        id: data?.id,
      };
      if (type === "subVendor")
        dispatch(
          patchUpdateVehicle({ ...profileData, subVendorId: companyId })
        );
      else {
        dispatch(patchUpdateVehicle({ ...profileData, cityId: companyId }));
      }
    } else if (iconType === "Activate") {
      const profileData = {
        isApproved: "Active",
        id: data?.id,
      };
      if (type === "subVendor")
        dispatch(
          patchUpdateVehicle({ ...profileData, subVendorId: companyId })
        );
      else {
        dispatch(patchUpdateVehicle({ ...profileData, cityId: companyId }));
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowOtherComponent(false);
  };

  const onFilterChange = (val) => {
    localStorage.removeItem("vehicleStatus");
    setPage(0);
    const defaultStatus = [
      "Active",
      "InActive",
      "Blocked",
      "Pending",
      "Rejected",
    ];

    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    setStatus(filterStatus);

    const driverFilterData = {
      ...filterData,
      status: filterStatus?.toString(),
      page: 0,
    };
    dispatch(getVehicle(driverFilterData));
  };

  const onRestFilter = () => {
    localStorage.removeItem("vehicleStatus");
    setStatus("");

    const driverFilterData = {
      ...filterData,
      status: "",
    };
    dispatch(getVehicle(driverFilterData));
  };

  const onSearch = debounce((e) => {
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
    };
    dispatch(getVehicle(searchFilterData));
  }, 1000);

  const closeUploadCompliance = () => {
    setShowOtherComponent(false);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <CommonButtonHeader
          defaultStatus={status}
          buttonFilterdata={filterStatusVehicle}
          buttontitle={"Vehicle +"}
          buttonFormData={vehicleDialogData(carOption)}
          onSubmittBtn={onSubmit}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          onSearch={onSearch}
          closeUploadCompliance={closeUploadCompliance}
        />
      </Grid>
      {vehicleLoader ? (
        <Loader />
      ) : (
        <CommonTable
          data={vehicleData}
          onClickTableVendor={onClickTableSubVendor}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          onClickMoreIcon={onClickMoreIcon}
          tabName={"vehicle"}
          isClickable={true}
        />
      )}
      {open && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={vehicleDialogData(carOption)}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          selectType={"edit"}
          type={'Upload Vehicle Compliance' }
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName="vehicle"
          vehicleId={iconId}
        />
      )}
    </div>
  );
}

export default VechileTable;
